import type { Lightning } from "@lightningjs/sdk";

const canvas = document.getElementById("lng-canvas") as HTMLCanvasElement;
const h = Math.min(window.screen.height, window.innerHeight);
const w = Math.min(window.screen.width, window.innerWidth);
const devicePixelRatio = Math.floor(1080 / h);

export const isWebGlSupported = (): boolean => {
  try {
    return !!(
      window.WebGLRenderingContext &&
      (canvas.getContext("webgl") || canvas.getContext("experimental-webgl"))
    );
  } catch (e) {
    return false;
  }
};

export const appSettings: Lightning.Application.Options = {
  debug: false,
  enablePointer: false,
  keys: {
    19: "PlayPause",
    27: "Back",
    32: "Stop",
    79: "Pause",
    80: "Play",
    116: "Rewind",
    117: "FastForward",
    118: "SkipBackward",
    119: "SkipForward",
    166: "Back",
    178: "Stop",
    179: "PlayPause",
    195: "Enter",
    196: "Back",
    199: "SkipForward",
    200: "SkipBackward",
    201: "Rewind",
    202: "FastForward",
    203: "Up",
    204: "Down",
    205: "Left",
    206: "Right",
    211: "Up",
    212: "Down",
    213: "Right",
    214: "Left",
    215: "Up",
    216: "Down",
    217: "Right",
    218: "Left",
    227: "Rewind",
    228: "FastForward",
    402: "PlayPause",
    412: "Rewind",
    413: "Stop",
    415: "Play",
    417: "FastForward",
    457: "Info",
    460: "Captions",
    461: "Back",
    463: "PlayPause",
    10009: "Back",
    10252: "PlayPause",
    65376: "Enter",
    65285: "Back",
    90000: "Enter",
    90001: "Back",
    90004: "SkipBackward",
    90005: "SkipForward",
    90006: "Rewind",
    90007: "FastForward",
    90012: "Up",
    90013: "Down",
    90014: "Left",
    90015: "Right",
  },
  stage: {
    bufferMemory: 1e6,
    canvas,
    canvas2d: !isWebGlSupported(),
    clearColor: 0x00000000,
    devicePixelRatio,
    h,
    memoryPressure: 1e7,
    precision: Number((h / 1080).toFixed(3)) / 1,
    useImageWorker: true,
    w,
  },
};

export default appSettings;
